import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import './Footer.scss'; // Import your styles (if needed)

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <footer className="footer">
      {/* Follow Us Section */}
      <div className='top-footer'>
        <div className="follow-us">
            <h3>Ακολουθήστε μας</h3>
            <div className="social-icons">
            <a href="#" aria-label="Facebook">
                <FontAwesomeIcon  icon={faFacebookF} className="social-icon" />
            </a>
            <a href="#" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} className="social-icon" />
            </a>
            <a href="#" aria-label="YouTube">
                <FontAwesomeIcon icon={faYoutube} className="social-icon" />
            </a>
            </div>
        </div>

        {/* Links Section */}
        {/* <div className="footer-links">
            <ul>
            <li>
                <a href="#">Contact Us</a>
            </li>
            <li>
                <a href="#">Our Company</a>
            </li>
            <li>
                <a href="#">Brands</a>
            </li>
            <li>
                <a href="#">Stores</a>
            </li>
            </ul>
        </div> */}
      </div>
      {/* Copyright Section */}
      <div className="copyright">
        <div className='company'>
            {currentYear} Ν. ΣΙΩΚΛΗΣ ΚΑΙ ΣΙΑ Ι.Κ.Ε.
        </div>
            <div className='bottom-footer'>
                {/* <a href="#">Terms of Use</a>
                <a href="#">Privacy Policy</a>
                <a href="#">Orders</a> */}
            </div>
      </div>
    </footer>
  );
};

export default Footer;